exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".t-fixed-footer{box-shadow:2px 0 5px 0 rgba(0,0,0,.5);text-align:center;z-index:10;width:510px;height:36px;line-height:36px;bottom:0;overflow:hidden;background:#27c3d9;position:fixed;left:50%;transform:translate(-50%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/footer/GlobalFooter.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/components/footer/GlobalFooter.scss
// module chunks = 0